<main class="wrapper">
    <div class="row">
        <div class="col-md-6">
            <div [class]="classeImagemFundo">
                <div class="saudacao" style="margin-top: 7%;">
                    <h1 style="color: white;"> <br>
                        <h2 style="color: white; margin-bottom: 0px;"> Bem-vindo ao </h2>
                        <strong style="font-size: 44px;">Portal dos Fundos Garantidores</strong><br> do <strong>BNDES</strong>
                    </h1>
                    <h6 style="margin-top: 13%;">
                        Instruções <br>
                    </h6>
                    <h6 style="margin-top: 2%; font-weight: lighter;">
                        Este sítio destina-se às instituições financeiras habilitadas a contratar operações com garantia dos Fundos <br>Garantidores administrados pelo BNDES. Todo acesso é registrado e auditado.<br><br>
                        <a style="color: white; font-weight: bold;" target="_blank" href="assets/pdfs/termos-de-uso-fundos-garantidores-e-fg-energia.pdf">Termos de uso e política de privacidade</a>
                    </h6>
                </div>        
            </div>
        </div>
        <div class="form col-md-6">
            <svg class="elemento-grafico circulo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 149.4 148.81"><path d="M149.4,0h-.59A148.8,148.8,0,0,0,0,148.81H149.4Z"/></svg>
            <svg class="elemento-grafico triangulo-topo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 785.2 269.81"><polygon points="0 0.14 0 0 785.2 0 785.2 269.81 0 0.14"/></svg>
            <svg class="elemento-grafico triangulo-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 785.2 269.81"><polygon points="785.2 269.67 785.2 269.81 0 269.81 0 0 785.2 269.67"/></svg>
            <div class="form__itens">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 204.88 42.19" class="logo"><title>Logo BNDES</title><path d="M12.16,14.85A14.53,14.53,0,0,0,0,21.42V41.55H20.15a14.55,14.55,0,0,0-8-26.7" fill="#fff"/><polygon points="0 0 0 16.79 16.62 0.17 41.38 24.93 24.76 41.55 41.55 41.55 41.55 0 0 0" fill="#fff"/><path d="M71.43,17.17C70,18.68,67.35,19,65.35,19H62.88l1.21-8.32h2.28c3.06,0,5.82.25,6,3.33a4,4,0,0,1-1,3.16m-1,15.95c-1.6,1.72-4.63,2-7.68,2h-2.1L62,25.18h2.06c3.73,0,7.21.49,7.46,4.06a4.92,4.92,0,0,1-1.11,3.88m3.78-11a8.63,8.63,0,0,0,6.22-8.79,8.71,8.71,0,0,0-4-7.17,15.07,15.07,0,0,0-8-1.94H57.19L52,41.56H62.85c6.92,0,11.78-1.45,14.46-4.33a9.42,9.42,0,0,0,2.32-7.38c-.28-4-2.24-6.77-5.43-7.76" fill="#fff"/><polygon points="117.94 4.19 110.29 4.19 106.38 31.11 96.93 4.19 87.07 4.19 81.65 41.56 89.41 41.56 93.15 14.41 102.46 41.56 112.47 41.56 117.94 4.19" fill="#fff"/><path d="M140,31.26c-2.35,2.53-6,3.81-10.75,3.81h-3l3.4-24.39h2.22c6.73,0,11,3.17,11.34,8.48s-.71,9.42-3.21,12.1M151.7,20.18c-.41-5.85-2.55-10.18-6.36-12.86-2.94-2.08-6.81-3.13-11.49-3.13H122.52l-5.26,37.37H130c7.5,0,13.19-2,16.93-6.05,4.7-5,5-11.77,4.74-15.33" fill="#fff"/><polygon points="164.99 10.68 179.33 10.68 180.12 4.19 157.81 4.19 152.56 41.56 175.13 41.56 176.09 35.07 161.59 35.07 162.92 25.49 175.79 25.49 176.64 19 163.83 19 164.99 10.68" fill="#fff"/><path d="M204.59,5.21l.29.12-1.47,6.77-.4-.2a17.74,17.74,0,0,0-7.59-1.85c-1.58,0-3.66.42-4.75,1.59a2.86,2.86,0,0,0-.76,2.24c.17,2.34,2.49,3.66,5.17,5.18,3.57,2,8,4.54,8.43,10.53.25,3.55-.63,6.42-2.61,8.55-2.46,2.65-6.6,4-12,4a32.18,32.18,0,0,1-10.72-2.07l-.31-.11,1.62-7,.39.17c2.69,1.21,5.82,2.49,9,2.49a6.91,6.91,0,0,0,5.11-1.86,4.45,4.45,0,0,0,1.13-3.49c-.19-2.79-2.68-4.13-5.56-5.68-3.57-1.92-7.62-4.1-8-9.66A9.7,9.7,0,0,1,184,7.44c2.33-2.5,6.17-3.88,10.8-3.88a26.88,26.88,0,0,1,9.75,1.65" fill="#fff"/></svg>
                <p>
                    Entre com seu login e senha.
                </p>
                <form #formLogin="ngForm" (ngSubmit)="executaLogin($event)">
                    <label class="form-label">
                            <span>CNPJ</span>
                            <input type="text"
                                #log_cnpj="ngModel"
                                data-testid="login-cnpj"
                                name="log_cnpj"
                                id="txt.CNPJ-ux4"
                                bn-mask-cpfcnpj bn-valid-cpfcnpj
                                [placeholder]="layoutCompacto ? (autoPreencherLogin ?   'CNPJ ou CPF' : 'CNPJ') : ''"
                                [(ngModel)]="model.log_cnpj"
                                maxlength="18"
                                autofocus
                                tabindex="1"
                                (blur)="tratarCNPJ()">
                                <div class="invalid-feedback" *ngIf="log_cnpj.invalid">
                                    <span *ngIf="log_cnpj.errors.required">Campo CNPJ/CPF é obrigatório.</span>
                                    <span *ngIf="log_cnpj.errors.cpfCnpjInvalido">O valor é inválido.</span>
                                </div>
                            </label>
                    <label class="form-label">
                            <span>Usuário</span>
                            <input type="text"
                            #log_userName="ngModel"
                            data-testid="login-usuario"
                            name="log_userName" 
                            id="txt.userName-ux4"
                            placeholder="{{layoutCompacto ? 'Usuário' : ''}}"
                            [(ngModel)]="model.log_userName"
                            maxlength="30"
                            aria-required="true"
                            [readOnly]="autoPreencherLogin"
                            tabindex="2"
                            required>
                            <div class="invalid-feedback" *ngIf="log_userName.invalid">
                                <span *ngIf="log_userName.errors.required">Campo usuário é obrigatório.</span>
                            </div>
                        </label>
                    <label class="form-label">
                            <span>Senha</span>
                            <input type="password"
                            #log_senha="ngModel"
                            data-testid="login-senha"
                            name="log_senha"
                            id="txt.senha-ux4"
                            placeholder="{{layoutCompacto ? 'Senha' : ''}}"
                            [(ngModel)]="model.log_senha"
                            maxlength="50"
                            aria-required="true"
                            tabindex="3"
                            required>
                            <div class="invalid-feedback" *ngIf="log_senha.invalid">
                                <span *ngIf="log_senha.errors.required">Campo senha é obrigatório.</span>
                            </div>
                        </label>
                    <div data-testid="recaptcha" class="row mb-3 d-flex justify-content-center" *ngIf="loginCaptchaChaveCliente && pedirCaptcha">
                        <ngx-recaptcha2 
                            #captchaElem 
                            [siteKey]="loginCaptchaChaveCliente"
                            [(ngModel)]="loginCaptchaResposta" 
                            name="recaptcha">
                        </ngx-recaptcha2>                  
                        
                        <!-- <input type="hidden" name="recaptcha" id="txt.recaptcha" [ngModel]="loginCaptchaResposta" [required]="pedirCaptcha"> -->
                    </div>
                    <div class="btns">
                        <button data-testid="entrar" class="btn entrar" id="btn.acessar-ux4" type="submit" aria-disabled="false" value="entrar" [disabled]="!formLogin.form.valid || carregando">
                            Entrar
                            <i class="bn-loading-in-button" *ngIf="carregando"></i>
                            </button>

                    </div>
                </form>
            </div>
        </div>   
    </div>
</main> 